export default __webpack_public_path__ + "img/bfc9d5d1eddc0401acf4c4c904fc439a.svg";